import { SparklesIcon } from '@heroicons/react/24/outline';
import { Tooltip } from '@odo/shared-ui';
import { useWhatsNewControls } from './whatsNewContext';

const LABEL = "What's new";

interface WhatsNewNavItemProps {
    collapsed: boolean;
}

export function WhatsNewNavItem({ collapsed }: WhatsNewNavItemProps) {
    const { openWhatsNew } = useWhatsNewControls();

    return (
        <Tooltip content={LABEL} side="right" disabled={!collapsed}>
            <button
                type="button"
                onClick={openWhatsNew}
                aria-label={collapsed ? LABEL : undefined}
                className={`flex h-10 items-center gap-2 px-3 py-2 w-full rounded-lg transition-colors duration-200 hover:bg-gray-100 text-gray-700 ${collapsed ? 'justify-center' : ''}`}
            >
                <SparklesIcon className="h-4 w-4 flex-shrink-0 text-yellow-500" />
                {!collapsed && <span className="text-sm font-medium">{LABEL}</span>}
            </button>
        </Tooltip>
    );
}
